import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="4" fill="#C7BCE4" fillOpacity="0.4" />
    <rect x="5" y="5" width="10" height="10" rx="2" fill="#5D5AB5" />
    <path
      d="M12.6663 8L8.99967 11.6667L7.33301 10"
      stroke="white"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="5" y="17" width="10" height="10" rx="2" fill="#C7BCE4" />
    <rect x="17" y="17" width="10" height="10" rx="2" fill="#C7BCE4" />
    <rect x="17" y="5" width="10" height="10" rx="2" fill="#C7BCE4" />
  </svg>
);

const BulkSelectionBlockIcon = (props) => <Icon component={svg} {...props} />;

export default BulkSelectionBlockIcon;
